import { unloggedStrapiAxios } from '../strapiAxios';
import { capture } from '../../services/sentry/capture';
import { getAxiosMessageError } from '../../helpers/errors/axios.error';

// Request API.
export const passwordForgotten = async (email: string): Promise<any> => {
  try {
    await unloggedStrapiAxios.post(
      '/users-permissions/users/askRenewPassword',
      {
        email
      }
    );

    return { success: true, message: 'Email envoyé' };
  } catch (error) {
    const message = getAxiosMessageError(error);
    capture(message, [error, email]);

    return { error: true, message };
  }
};
